import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import type { FilterValue, SorterResult } from 'antd/lib/table/interface';
import styled from "@emotion/styled";
import { SearchPanel } from "screens/job/all-jobs/search-panel";
import { JobList } from "components/listing/job-list";
import { useDebounce, useDocumentTitle } from "utils";

import { Row } from "components/lib";
import { Profiler } from "components/profiler";
import { useJobs } from "utils/job";
import { useJobSearchParams, useSorterSearchParams } from "../../../search-utils/util";
import { useUrlQueryPaging } from "../../../utils/paging";
import useWindowSize from "hooks/useWindowSize";
import PageContainer from "../../../components/layout/PageContainer";

export const AllJobsScreen = () => {
  useDocumentTitle("job lists", false);
  const navigate = useNavigate();
  const { windowHeight } = useWindowSize();

  const [param, setParam] = useJobSearchParams();
  const [pageObject, setPageObject] = useUrlQueryPaging();
  const [sorterObject, setSorterObject] = useSorterSearchParams();

  const { isLoading, error, data, retry } = useJobs(
    useDebounce(param, 500),
    pageObject,
    sorterObject
  );

  return (
    <Profiler id={"job lists"}>
      <PageContainer>
        <SearchPanel param={param} setParam={setParam} />
        <ContentContainer>
          <Row marginBottom={2} between={true}>
            <h1>Job list</h1>
            <Button type="primary" onClick={() => navigate("/create_job")}>
              ＋Create job
            </Button>
          </Row>

          <JobList
            refresh={retry}
            setSorterObject={setSorterObject}
            tableProps={{
              loading: isLoading,
              dataSource: data?.list || [],
              pagination: false,
              scroll: {
                y: windowHeight - 320,
              },
            }}
            paginationProps={{
              pageSize: pageObject.pageSize,
              current: pageObject.pageNumber,
              total: data?.total || 0,
              onChange: (page, pageSize) => {
                setPageObject({
                  pageSize,
                  pageNumber: page,
                });
              }
            }}
          />
        </ContentContainer>
      </PageContainer>
    </Profiler>
  );
};

const ContentContainer = styled.div`
  padding: 3.2rem;
`;

AllJobsScreen.whyDidYouRender = false;
